// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  NewQuotePriceEscalation,
  type QuotePriceEscalation,
  type QuotePriceEscalationWireFormat,
} from '../QuotePriceEscalation/QuotePriceEscalation';
import {
  NewQuoteRevisionOrigin,
  type QuoteRevisionOrigin,
  type QuoteRevisionOriginWireFormat,
} from '../QuoteRevisionOrigin/QuoteRevisionOrigin';
import {
  NewQuoteRevisionProduct,
  type QuoteRevisionProduct,
  type QuoteRevisionProductWireFormat,
} from '../QuoteRevisionProduct/QuoteRevisionProduct';

export class QuoteRevision {
  readonly id: string;
  readonly revisionNumber: number;
  readonly revisionDate: DateTime | null;
  readonly createdAt: DateTime;
  readonly origin: QuoteRevisionOrigin | null;
  readonly products: QuoteRevisionProduct[];
  readonly priceEscalations: QuotePriceEscalation[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.revisionNumber = data.revisionNumber === undefined ? 0 : data.revisionNumber;
    this.revisionDate = DateHelpers.ParseServerNullableDate(data.revisionDate);
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.origin =
      // eslint-disable-next-line no-nested-ternary
      (data.origin ?? null) === null ? null : NewQuoteRevisionOrigin(data.origin);
    this.products = (data.products ?? []).map((products: any) => NewQuoteRevisionProduct(products));
    this.priceEscalations = (data.priceEscalations ?? []).map((priceEscalations: any) =>
      NewQuotePriceEscalation(priceEscalations),
    );
  }

  static zero(): QuoteRevision {
    const zeroValues: ExcludeMethodsDeep<QuoteRevision> = {
      id: NIL_UUID,
      revisionNumber: 0,
      revisionDate: null,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      origin: null,
      products: [],
      priceEscalations: [],
    };
    return new QuoteRevision(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteRevisionWireFormat = {
  id: string;
  revisionNumber: number;
  revisionDate: string | null;
  createdAt: string;
  origin: QuoteRevisionOriginWireFormat | null;
  products: QuoteRevisionProductWireFormat[];
  priceEscalations: QuotePriceEscalationWireFormat[];
};

type NewQuoteRevisionProps = PartialDeep<QuoteRevision, { recurseIntoArrays: true }>;
export const NewQuoteRevision: (props: NewQuoteRevisionProps) => QuoteRevision = (props) =>
  new QuoteRevision(props);

type NewQuoteRevisionFromWireFormatProps = PartialDeep<
  QuoteRevisionWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteRevisionFromWireFormat: (
  props: NewQuoteRevisionFromWireFormatProps,
) => QuoteRevision = (props) => new QuoteRevision(props);
